enum Module {
  Integrations = 'Integrations',
  Organization = 'Organization',
  Providers = 'Providers',
  ViewSensitiveInfo = 'ViewSensitiveInfo',
  ProviderRemoval = 'ProviderRemoval',
  SensitiveCvoActions = 'SensitiveCvoActions',
  Enrollments = 'Enrollments',
  ProviderChangeCredentialingStatus = 'ProviderChangeCredentialingStatus',
  BulkMonitoringActions = 'BulkMonitoringActions'
}

export default Module;
